import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const schema = process.env.REACT_APP_DB_SCHEMA || 'public';

console.log('Using Supabase schema:', schema);  // For debugging

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: { schema },
});


